"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Numbers {
    static range(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }
    /**
     * Try to parse the value, if parse doesn't result in valid number, defaultsTo is used.
     */
    static tryParseInt(value, defaultsTo = 0) {
        const number = Number.parseInt(value);
        if (isNaN(number)) {
            return defaultsTo;
        }
        return number;
    }
    /**
     * Throws error when value is not valid number
     */
    static parseInt(value) {
        const number = Number.parseInt(value);
        if (isNaN(number)) {
            throw new Error('Invalid number value: ' + value);
        }
        return number;
    }
}
exports.default = Numbers;
//# sourceMappingURL=Numbers.js.map